import * as types from './actionTypes';

const initialState = {
  usedBonuses: 0,
  gifts: {
    list: [],
    isLoading: false,
    isLoaded: false,
    error: '',
  },
};

export default function sailplayReducer(state = initialState, action) {
  switch (action.type) {
    case types.ACTIVATE_BONUSES_USAGE: {
      return {
        ...state,
        usedBonuses: Math.floor(Number(action.payload)),
      };
    }

    case types.FETCH_GIFTS_REQUEST: {
      return {
        ...state,
        gifts: {
          isLoading: true,
          isLoaded: false,
          list: [],
          error: '',
        },
      };
    }

    case types.FETCH_GIFTS_SUCCESS: {
      return {
        ...state,
        gifts: {
          isLoading: false,
          isLoaded: true,
          list: action.payload,
          error: '',
        },
      };
    }

    case types.FETCH_GIFTS_FAILURE: {
      return {
        ...state,
        gifts: {
          isLoading: false,
          isLoaded: true,
          list: [],
          error: action.payload,
        },
      };
    }

    default:
      return state;
  }
}
